import { createApp } from 'vue';
import VueLazyload from 'vue-lazyload';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';

import PayoutsList from '../pages/PayoutsList.vue';
import OrderPayoutsList from '../pages/OrderPayoutsList.vue';

import PayoutItem from '../components/PayoutItem.vue';
import OrderPayoutItem from '../components/OrderPayoutItem.vue';
import SearchInput from '../components/SearchInput.vue';
import NavPanel from '../components/NavPanel.vue';
import DateRangePicker from '../components/DateRangePicker.vue';


class ProfilePayoutsComponent {
  constructor({ container }) {
    this.app = null;
    this.container = container;
  }
  init() {
    // 根據容器 ID 決定使用哪個組件
    const isPayoutsList = this.container === '#payouts-list';
    const isOrderPayoutsList = this.container === '#order-payouts-list';

    if (!isPayoutsList && !isOrderPayoutsList) {
      console.error('Invalid container ID for ProfilePayoutsComponent');
      return;
    }
    const RootComponent = isPayoutsList ? PayoutsList : OrderPayoutsList;

    this.app = createApp(RootComponent);
    this.app.use(I18NextVue, { i18next });
    this.app.use(VueLazyload, {
      preLoad: 2.6 // default 1.3
    });

    this.app.component('payout-item', PayoutItem);
    this.app.component('order-payout-item', OrderPayoutItem);
    this.app.component('search-input', SearchInput);
    this.app.component('nav-panel', NavPanel);
    this.app.component('date-range-picker', DateRangePicker);

    // Mount the Vue app to the specified container
    this.app.mount(this.container);
  }
}

export default ProfilePayoutsComponent;